export default "__VITE_ASSET__BCA5PEt1__"